import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForms = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 129.61,
			y: 103.91,
			width: 224.74,
			height: 276.12,
			fill: "none",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 15.56
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "382.39 131.96 382.39 408.09 157.66 408.09 157.66 380.04 354.34 380.04 354.34 131.96 382.39 131.96",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8.42
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 205.59,
			y: 151.58,
			width: 115.78,
			height: 25.56,
			fill: "none",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 11.22
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.82,164.36c0,5.64-4.54,10.12-10.12,10.12s-10.12-4.49-10.12-10.12,4.54-10.12,10.12-10.12,10.12,4.54,10.12,10.12Z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 7.83
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.82,221.75c0,5.64-4.54,10.12-10.12,10.12s-10.12-4.49-10.12-10.12,4.54-10.12,10.12-10.12,10.12,4.54,10.12,10.12Z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 7.83
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.82,279.14c0,5.64-4.54,10.12-10.12,10.12s-10.12-4.49-10.12-10.12,4.54-10.12,10.12-10.12,10.12,4.54,10.12,10.12Z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 7.83
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 205.59,
			y: 208.97,
			width: 115.78,
			height: 25.56,
			fill: "none",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 11.22
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 205.59,
			y: 266.36,
			width: 115.78,
			height: 25.56,
			fill: "none",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 11.22
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 262.79,
			y: 323.75,
			width: 38.71,
			height: 18.24,
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 11.22
		})
	]
});
export default SvgForms;
